import React, { createContext, useContext, useState, useCallback } from "react";
import translations from "./translations";

const LanguageContext = createContext(null);

// Helper: access nested key with dot notation e.g. "nav.findHome"
function resolve(obj, path) {
  return path.split(".").reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : path), obj);
}

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("gb_lang") || "en");

  const switchLang = useCallback((l) => {
    setLang(l);
    localStorage.setItem("gb_lang", l);
  }, []);

  const t = useCallback(
    (key) => resolve(translations[lang], key),
    [lang]
  );

  return (
    <LanguageContext.Provider value={{ lang, switchLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used inside LanguageProvider");
  return ctx;
}
